import { useQuery } from "@tanstack/react-query";
import axios from "../axios-orders";
import { SellerKpiResponse } from "../types";
import { queryKeys } from "./queryKeys";

const fetchSellerKpis = async (): Promise<SellerKpiResponse> => {
  const response = await axios.get("/seller/kpis");
  return response.data;
};

export const useSellerKpis = () =>
  useQuery<SellerKpiResponse, Error>({
    queryKey: [queryKeys.SELLER_KPIS],
    queryFn: fetchSellerKpis,
  });
